var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "120px",
    viewBox: "0 0 128 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    stroke: "#E7EEF1",
    fill: "#F4F7FC",
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 119,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    transform: "translate(34, 40)",
    fill: "#37474F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.84,0 L5.16,0 C2.3108965,0.00165050392 0.00165501262,2.30460101 0,5.14594279 L0,35.8540572 C0.00165501262,38.695399 2.3108965,40.9983495 5.16,41 L54.84,41 C57.6891035,40.9983495 59.998345,38.695399 60,35.8540572 L60,5.14594279 C59.998345,2.30460101 57.6891035,0.00165050392 54.84,0 L54.84,0 Z M54.84,1.19672948 C55.7185043,1.1959908 56.5719264,1.48881877 57.264,2.02845884 L37.125,22.2741535 C35.2406339,24.1697446 32.67502,25.2360626 29.9985,25.2360626 C27.32198,25.2360626 24.7563661,24.1697446 22.872,22.2741535 L2.736,2.02845884 C3.42851967,1.48963852 4.28164975,1.19672948 5.16,1.19672948 L54.84,1.19672948 Z M1.2,5.14594279 C1.20055615,4.34155728 1.44758755,3.55655079 1.908,2.89608873 L19.482,20.5658202 L2.001,38.2176007 C1.48297222,37.5377978 1.20171646,36.7078849 1.2,35.8540572 L1.2,5.14594279 Z M5.16,39.8032691 C4.33240498,39.8006211 3.52690511,39.5366929 2.859,39.0493287 L20.328,21.3975482 L22.02,23.0998978 C24.1300837,25.2213026 27.0022637,26.4145409 29.9985,26.4145409 C32.9947363,26.4145409 35.8669163,25.2213026 37.977,23.0998978 L39.672,21.3975482 L57.141,39.0493287 C56.4705314,39.5298996 55.6656755,39.7883843 54.84,39.78831 L5.16,39.8032691 Z M58.8000002,35.8540572 C58.8002473,36.7109577 58.5188888,37.5443264 57.999,38.2265762 L40.515,20.5747957 L58.092,2.90506421 C58.5515318,3.56258642 58.7985669,4.34447296 58.8000002,5.14594279 L58.8000002,35.8540572 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNew);
export default __webpack_public_path__ + "static/media/Email_new.ed0573788f8013a62036f16ea5298c24.svg";
export { ForwardRef as ReactComponent };